module.exports = __webpack_public_path__ + "static/tram-3331e841ee876137bf108dd6385ea82e.png";